module.exports = __webpack_public_path__ + "img/image-avatar.ad0c5219.png";